import React, { Dispatch, SetStateAction } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "@clarkinc/zest-design-system/ui";

interface Props {
  modalOpen: boolean;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
  cartLimitMessage: string;
}

/**
 * @deprecated Please use `src/features/shopping/ui/modal/CartLimit` instead
 */
export default ({ modalOpen, setModalOpen, cartLimitMessage }: Props) => {
  return (
    <Modal
      aria-label="Cart Limit Modal"
      open={modalOpen}
      onOpenChange={() => setModalOpen(false)}
      className="max-w-xl"
      theme="wss"
      data-testid="cart-limit-modal"
    >
      <ModalHeader>Cart Limit Reached</ModalHeader>
      <ModalBody className="flex-grow overflow-auto">
        <p className="text-base">{cartLimitMessage}</p>
      </ModalBody>
      <ModalFooter>
        <Button
          aria-label="Close"
          variant="primary"
          type="button"
          color="white"
          onClick={() => setModalOpen(false)}
          data-testid="cart-limit-button"
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
